import type { StorageInstance } from 'storage/domain/Storage'
import type { MasterData } from 'types/masterData'
import type { AuthOrchestratorData } from '../../types/auth'
import { sessionCache } from '../sessionCache'

type SessionCacheStorage = AuthOrchestratorData & { TIMESTAMP?: number }

export const getSessionCacheStorage = async (
	masterData: MasterData
): Promise<SessionCacheStorage | null> => {
	const sessionStorage: StorageInstance = sessionCache(masterData)
	const session =
		await sessionStorage.getAllKeysFromCache<SessionCacheStorage>()

	if (session?.token) {
		return session as unknown as SessionCacheStorage
	}
	return null
}
